"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  role: true,
  scoped: true,
  allowTransparency: true,
  // works only in IE
  capture: true,
  challenge: true,
  // deprecated
  classID: true,
  contextMenu: true,
  formEncType: true,
  icon: true,
  inputMode: true,
  is: true,
  keyParams: true,
  keyType: true,
  manifest: true,
  // html,
  mediaGroup: true,
  nonce: true,
  profile: true,
  radioGroup: true,
  seamless: true,
  wmode: true,
  about: true,
  datatype: true,
  inlist: true,
  property: true,
  resource: true,
  typeof: true,
  vocab: true,
  autoCorrect: true,
  autoSave: true,
  results: true,
  security: true,
  unselectable: true
};